module.exports = __webpack_public_path__ + "assets/img/be3003edab88f5d6fd395fcb99887b61.svg";